import { useRef, useState } from "react";
import BaseModal from "./BaseModal";
import UploadIcon from "../icons/UploadIcon";
import "../../css/BaseModal.css";
import "../../css/GenerateAReportModal.css";
import { putInputData } from "../../api/reportApi";
import { useParams } from "react-router-dom";

/**
 * A modal component for generating a report in the admin reports page.
 *
 * @component
 * @param props - Component props.
 * @param {Boolean} props.isOpen - Controls whether the modal is open or closed.
 * @param {Function} props.onRequestClose - Callback function triggered to close the modal, passed down to BaseModal.
 * @param {String} [props.width='auto'] - Optional width of the modal content, defaults to 'auto' if not provided.
 * @returns {JSX.Element} The rendered GenerateAReportModal component.
 */
const GenerateAReportModal = ({ isOpen, onRequestClose, width, onUpload }) => {
  const fileInputRef = useRef(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const frontendPath = window.location.pathname;
  const { restaurantId } = useParams();

  const handleContainerClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file);
      // handle the uploaded file (e.g., read content, upload to server, etc.)
    }
  };

  const handleUpload = async () => {
    if (!selectedFile) {
      return;
    }

    const formData = new FormData();
    formData.append("file", selectedFile);

    setUploading(true);
    try {
      await putInputData(restaurantId, frontendPath, selectedFile);
    } catch (error) {
      console.error("Error in uploading file:", error);
    }
    setUploading(false);
    onUpload();
  };

  return (
    <BaseModal isOpen={isOpen} onRequestClose={onRequestClose} width={width}>
      <div className="base-modal">
        <div className="GenerateAReportModal">
          <p className="GenerateAReportModal-description">
            upload your restaurant's data for the week and we'll generate a
            report for you!
          </p>
          <div
            className="GenerateAReportModal-upload-csv-container"
            onClick={handleContainerClick}
          >
            <UploadIcon
              className="GenerateAReportModal-upload-icon"
              size="50px"
            />
            <h3>upload .xlsx</h3>
          </div>
          <input
            type="file"
            accept=".xlsx"
            ref={fileInputRef}
            style={{ display: "none" }}
            onChange={handleFileChange}
          />
          {selectedFile && (
            <div className="GenerateAReportModal-file-info">
              <button
                onClick={handleUpload}
                disabled={uploading}
                className="GenerateAReportModal-upload-button"
              >
                {uploading ? "Uploading..." : "Upload"}
              </button>
            </div>
          )}
        </div>
      </div>
    </BaseModal>
  );
};

export default GenerateAReportModal;
